import { Warning } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'

import classes from './index.styles'

const Nh3Item = ({ value, isAlerting }: { value: number; isAlerting: boolean }) => {
  const ariaLabel = `${value || 'Unknown'} PPM`

  return (
    <Grid container={true} sx={classes.textValueContainer}>
      <Typography variant="body1" sx={classes.label} aria-label={ariaLabel}>
        {value || '--'}
        <Typography variant="caption" sx={classes.ppmLabel}>
          PPM
        </Typography>
      </Typography>
      {isAlerting && <Warning sx={classes.statusItemWarningIcon} />}
    </Grid>
  )
}

export default Nh3Item
